import { useFormik } from 'formik'
import React, { useCallback, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import styled from 'styled-components'
import * as Yup from 'yup'
import api from '../../../api'
import Responsive from '../../../assets/config/Responsive'
import Colors from '../../../assets/styles/Colors'
import Loader from '../../../components/Loader'
import BackgroundIcon from '../../../components/v2/BackgroundIcon'
import BirthDayInput from '../../../components/v2/BirthDayInput'
import Dropdown from '../../../components/v2/Dropdown'
import GenderCard from '../../../components/v2/GenderCard'
import Input from '../../../components/v2/Input'
import MovingPrice from '../../../components/v2/MovingPrice'
import ScreenHeader from '../../../components/v2/ScreenHeader'
import Title from '../../../components/v2/Title'
import WarningMessage from '../../../components/v2/WarningMessage'
import NavigationButton from '../../../components/v2/buttons/NavigationButton'
import TplProgressbar from '../../../components/v2/progrees-bars/TplProgressbar'
import { useAppDispatch, useAppSelector } from '../../../store'
import { AppState } from '../../../store/appSlice'
import { TplState, setInsuredInfo, setInsuredObj, setInsuredTranslationInfo } from '../../../store/tplSlice'
import { Helmet } from 'react-helmet-async'
//
//
const TplForOther = () => {
  //
  const dispatch = useAppDispatch()
  //
  const { lang, isProduction } = useAppSelector((root: { app: AppState }) => root.app)
  //
  const { t } = useTranslation()
  //
  const navigate = useNavigate()
  //
  const { checkout, filter, screenHeader } = useAppSelector((data: { tpl: TplState }) => data.tpl)
  //
  // countries array from api
  const { data: countries, isLoading: isCountriesLoading } = api.useGetCountriesQuery(undefined)
  //
  // Sgs request
  const [sgsRequest, { isLoading: isSgsRequestLoading, data: sgsResult }] = api.useSgsRequestMutation()
  //
  // page info
  const { data: tplInsuredPersonsInfo, isLoading: isTplInsuredPersonsInfoLoading } =
    api.useGetTplInsuredPersonsInfoQuery(undefined)
  //
  //
  const pageTitle = tplInsuredPersonsInfo?.translations[lang]?.title
  const stepName = tplInsuredPersonsInfo?.translations[lang]?.stepName
  //
  //
  // SGS & set user info from SGS & if user not logged
  const requestSgsAndSetResponseData = useCallback(async () => {
    //
    const newUserSgsVerification =
      !checkout.insured.sgsVerification &&
      !checkout.insured.sgsVerificationSended &&
      checkout.insured.cityzenship === 'GE' &&
      checkout.insured.dateOfbirth &&
      checkout.insured.idNumber &&
      checkout.insured.idNumber.length === 11
    //
    //
    const dateFormatRegex = /^(0[1-9]|[12][0-9]|3[01])\s*\/\s*(0[1-9]|1[0-2])\s*\/\s*(\d{4})$/
    //
    const isValidDateFormat = dateFormatRegex.test(checkout.insured.dateOfbirth as never as string)
    //
    //
    if (newUserSgsVerification && isValidDateFormat && isProduction) {
      //
      // Convert the input date string to a JavaScript Date object
      const dateParts =
        checkout.insured.dateOfbirth &&
        (checkout.insured.dateOfbirth as never as string)?.split('/').map((part) => part.trim())
      const formattedDate = dateParts && new Date(`${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`)

      // Format the date to "YYYY-MM-DD"
      const formattedDateString = formattedDate && formattedDate?.toISOString()?.split('T')[0]
      //
      if (formattedDateString && checkout.insured.idNumber && isProduction) {
        //
        dispatch(
          setInsuredInfo({
            fieldName: 'sgsVerificationSended',
            fieldValue: true,
          }),
        )
        //
        try {
          //
          await sgsRequest({ birthday: formattedDateString, personalNumber: checkout.insured.idNumber }).unwrap()
          //
        } catch (error: any) {
          if (error?.data?.errors?.constructor === Array) {
            const firstError = error.data.errors[0]
            const errorMessage = firstError.message
            toast.error(errorMessage)
          }
        }
      }
      //
    }
    //
  }, [
    isProduction,
    checkout.insured.cityzenship,
    checkout.insured.dateOfbirth,
    checkout.insured.idNumber,
    checkout.insured.sgsVerification,
    checkout.insured.sgsVerificationSended,
    sgsRequest,
    dispatch,
  ])
  //
  // send SGS request
  useEffect(() => {
    requestSgsAndSetResponseData()
    //
    return () => {}
  }, [requestSgsAndSetResponseData])
  //
  // SGS
  //
  //
  //
  //
  //
  const setSgsUserDataCallBack = useCallback(() => {
    //
    // set sgs response data
    if (isProduction && sgsResult && sgsResult.sgsStatusText && sgsResult.sgsStatusText.toLowerCase() === 'ok') {
      return [
        dispatch(
          setInsuredObj({
            cityzenship: checkout.insured.cityzenship,
            dateOfbirth: checkout.insured.dateOfbirth,
            passportNumber: checkout.insured.passportNumber,
            idNumber: checkout.insured.idNumber,
            gender: sgsResult.gender,
            sgsVerification: true,
            sgsVerificationSended: true,
            translations: {
              ge: {
                firstName: sgsResult.translations?.ge?.firstName,
                lastName: sgsResult.translations?.ge?.lastName,
              },
              en: {
                firstName: sgsResult.translations?.en?.firstName || '',
                lastName: sgsResult.translations?.en?.lastName || '',
              },
            },
          }),
        ),
      ]
    }
    //
  }, [
    checkout.insured.cityzenship,
    checkout.insured.dateOfbirth,
    checkout.insured.idNumber,
    checkout.insured.passportNumber,
    sgsResult,
    isProduction,
    dispatch,
  ])
  //
  //
  useEffect(() => {
    setSgsUserDataCallBack()
    //
    return () => {}
  }, [setSgsUserDataCallBack])
  //
  //
  //
  //
  const calculateAgeFromDate = (dateString: any) => {
    if (typeof dateString === 'string') {
      // Remove any leading or trailing white spaces from the string
      dateString = dateString.replace(/\s/g, '')

      // Check if the trimmed date string is not empty
      if (dateString) {
        // Extract day, month, and year from the string
        var parts = dateString.split('/')
        if (parts.length === 3) {
          var day = parseInt(parts[0], 10)
          var month = parseInt(parts[1], 10)
          var year = parseInt(parts[2], 10)

          // Check if the extracted values are valid numbers
          if (!isNaN(day) && !isNaN(month) && !isNaN(year)) {
            var birthDate = new Date(year, month - 1, day)

            // Check if the birthDate is a valid date
            if (
              birthDate instanceof Date &&
              !isNaN(birthDate.getTime()) &&
              birthDate.getFullYear() === year &&
              birthDate.getMonth() === month - 1 &&
              birthDate.getDate() === day
            ) {
              // Calculate the difference in years
              var ageDiff = Date.now() - birthDate.getTime()
              var ageDate = new Date(ageDiff)

              return Math.abs(ageDate.getUTCFullYear() - 1970)
            }
          }
        }
      }
    }

    return null
  }
  //
  //
  const diffage = calculateAgeFromDate(checkout.insured?.dateOfbirth)
  //
  //
  //
  //
  // english letter regex
  const englishLetterRegex = /^[A-Za-z]+$/
  // georgian letter regex
  const georgianLetterRegex = /^[\u10D0-\u10FF]*$/
  //
  // yup validations schema
  const PersonalInfoValidationSchema = Yup.object({
    firstName: Yup.string()
      .min(2, `${t('minNameLetterLenght')}`)
      .matches(/^\S*$/, `${t('spaceValidation')}`)
      .matches(englishLetterRegex, `${t('onlyEnglishLetters')}`)
      .required(`${t('required')}`),
    lastName: Yup.string()
      .min(2, `${t('minSurnameLetterLenght')}`)
      .matches(/^\S*$/, `${t('spaceValidation')}`)
      .matches(englishLetterRegex, `${t('onlyEnglishLetters')}`)
      .required(`${t('required')}`),
    firstNameGe: Yup.string()
      .min(2, `${t('minNameLetterLenght')}`)
      .matches(/^\S*$/, `${t('spaceValidation')}`)
      .matches(georgianLetterRegex, `${t('onlyGeorgianLetters')}`)
      .required(`${t('required')}`),
    lastNameGe: Yup.string()
      .min(2, `${t('minSurnameLetterLenght')}`)
      .matches(/^\S*$/, `${t('spaceValidation')}`)
      .matches(georgianLetterRegex, `${t('onlyGeorgianLetters')}`)
      .required(`${t('required')}`),
    idNumber: Yup.string()
      .min(11, `${t('personalNumberValidation')}`)
      .max(11, `${t('personalNumberValidation')}`)
      .matches(/^\S*$/, `${t('spaceValidation')}`)
      .required(`${t('required')}`),
    gender: Yup.string()
      .matches(/^\S*$/, `${t('spaceValidation')}`)
      .required(`${t('required')}`),
  })
  //
  const MainValidationSchema = PersonalInfoValidationSchema
  //
  // initial values
  const initialValues = {
    firstName: checkout.insured.translations?.en?.firstName || '',
    lastName: checkout.insured.translations?.en?.lastName || '',
    firstNameGe: checkout.insured.translations?.ge?.firstName || '',
    lastNameGe: checkout.insured.translations?.ge?.lastName || '',
    idNumber: checkout.insured.idNumber || '',
    gender: checkout.insured.gender || '',
  }
  // formi state
  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: MainValidationSchema,
    enableReinitialize: true,
    onSubmit: (values) => {
      console.log(values)
    },
  })
  //
  //
  // auto navigate first page
  useEffect(() => {
    if (!filter.dates?.start) {
      navigate('/tpl-choose-days')
    }
    //
    return () => {}
  }, [filter.dates?.start, navigate])
  //
  //
  const MainLoading = isCountriesLoading || isTplInsuredPersonsInfoLoading || isSgsRequestLoading
  //
  return MainLoading ? (
    <Loader />
  ) : (
    <Wrapper>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageTitle} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>

      <ScreenHeader totalCount={screenHeader.totalCount} passedCount={screenHeader.passedCount} />

      <Content>
        <Title text={pageTitle} />

        <TplProgressbar stepName={stepName} />

        <MovingPrice price={filter.offerTotalPrice} currency={filter.currency} />

        <WhiteBox>
          <BoxTitle>{pageTitle}</BoxTitle>

          <Inputs>
            {countries && (
              <Dropdown
                title={`${t('cityzenship')}`}
                isSearchable={true}
                value={countries.find((x) => x.isoCode === checkout.insured?.cityzenship)?.isoCode}
                options={[
                  ...countries.map((c) => ({
                    value: c.isoCode,
                    label: c.translations?.[lang]?.name,
                  })),
                ]}
                onChange={(value) =>
                  dispatch(
                    setInsuredInfo({
                      fieldName: 'cityzenship',
                      fieldValue: value.value,
                    }),
                  )
                }
              />
            )}

            <Input
              id="id-number"
              name="idNumber"
              label={`${t('personalNumber')}`}
              type="text"
              placeholder=""
              value={checkout.insured.idNumber || ''}
              onChange={(value) => [
                dispatch(
                  setInsuredInfo({
                    fieldName: 'idNumber',
                    fieldValue: value,
                  }),
                ),
                formik.setFieldValue('idNumber', value),
              ]}
              width={'fullWidth'}
              error={formik.errors.idNumber && checkout.insured.idNumber ? true : false}
              errorText={formik.errors.idNumber}
              onBlur={formik.handleBlur}
              disabled={checkout.insured.sgsVerification === true && checkout.insured.idNumber ? true : false}
            />

            {checkout.insured.dateOfbirth !== undefined && diffage && diffage < 18 && (
              <WarningMessage variant="light-red" text={t('ageIsNotValid')} />
            )}

            <BirthDayInput
              width={'fullWidth'}
              disabled={checkout.insured.sgsVerification === true && checkout.insured.dateOfbirth ? true : false}
              id="date-of-birth"
              label={t('dateOfBirth')}
              placeholder={t('dayMonthYear')}
              // @ts-ignore
              value={checkout.insured.dateOfbirth || ''}
              onChange={(value: string) => {
                return [
                  dispatch(
                    setInsuredInfo({
                      fieldName: 'dateOfbirth',
                      fieldValue: value,
                    }),
                  ),
                  formik.setFieldValue('dateOfbirth', value),
                ]
              }}
            />

            <>
              {checkout.insured.cityzenship === 'GE' && (
                <Input
                  id="georgian-first-name"
                  name="firstNameGe"
                  label={`${t('nameInGeorgia')}`}
                  type="text"
                  placeholder=""
                  value={checkout.insured.translations?.ge?.firstName || ''}
                  onChange={(value) => [
                    dispatch(
                      setInsuredTranslationInfo({
                        language: 'ge',
                        fieldName: 'firstName',
                        fieldValue: value,
                      }),
                    ),
                    formik.setFieldValue('firstNameGe', value),
                  ]}
                  width={'fullWidth'}
                  error={formik.errors.firstNameGe && checkout.insured.translations?.ge?.firstName ? true : false}
                  errorText={formik.errors.firstNameGe}
                  onBlur={formik.handleBlur}
                  disabled={
                    checkout.insured.sgsVerification === true && checkout.insured.translations?.ge?.firstName
                      ? true
                      : false
                  }
                />
              )}
            </>

            <>
              {checkout.insured.cityzenship === 'GE' && (
                <Input
                  id="georgian-last-name"
                  name="lastNameGe"
                  label={`${t('surnameInGeorgia')}`}
                  type="text"
                  placeholder=""
                  value={checkout.insured.translations?.ge?.lastName || ''}
                  onChange={(value) => [
                    dispatch(
                      setInsuredTranslationInfo({
                        language: 'ge',
                        fieldName: 'lastName',
                        fieldValue: value,
                      }),
                    ),
                    formik.setFieldValue('lastNameGe', value),
                  ]}
                  width={'fullWidth'}
                  error={formik.errors.lastNameGe && checkout.insured.translations?.ge?.lastName ? true : false}
                  errorText={formik.errors.lastNameGe}
                  onBlur={formik.handleBlur}
                  disabled={
                    checkout.insured.sgsVerification === true && checkout.insured.translations?.ge?.lastName
                      ? true
                      : false
                  }
                />
              )}
            </>

            <Input
              id="english-first-name"
              name="firstName"
              label={`${t('nameInEnglish')}`}
              type="text"
              placeholder=""
              value={checkout.insured.translations?.en?.firstName || ''}
              onChange={(value) => [
                dispatch(
                  setInsuredTranslationInfo({
                    language: 'en',
                    fieldName: 'firstName',
                    fieldValue: value,
                  }),
                ),
                formik.setFieldValue('firstName', value),
              ]}
              width={'fullWidth'}
              error={formik.errors.firstName && checkout.insured.translations?.en?.firstName ? true : false}
              errorText={formik.errors.firstName}
              onBlur={formik.handleBlur}
              disabled={false}
            />

            <Input
              id="english-last-name"
              name="lastName"
              label={`${t('surnameInEnglish')}`}
              type="text"
              placeholder=""
              value={checkout.insured.translations?.en?.lastName || ''}
              onChange={(value) => [
                dispatch(
                  setInsuredTranslationInfo({
                    language: 'en',
                    fieldName: 'lastName',
                    fieldValue: value,
                  }),
                ),
                formik.setFieldValue('lastName', value),
              ]}
              width={'fullWidth'}
              error={formik.errors.lastName && checkout.insured.translations?.en?.lastName ? true : false}
              errorText={formik.errors.lastName}
              onBlur={formik.handleBlur}
              disabled={false}
            />

            <>
              <ChooseGenderLabel>{t('chooseGender')}</ChooseGenderLabel>
              <GenderBlock
                style={{
                  userSelect: checkout.insured.sgsVerification === true && checkout.insured.gender ? 'none' : 'unset',
                  //
                  pointerEvents:
                    checkout.insured.sgsVerification === true && checkout.insured.gender ? 'none' : 'unset',
                }}
              >
                <GenderCard
                  selected={checkout.insured.gender === 'female'}
                  gender="female"
                  femaleText={`${t('female')}`}
                  onClick={() => [
                    dispatch(
                      setInsuredInfo({
                        fieldName: 'gender',
                        fieldValue: 'female',
                      }),
                    ),
                    formik.setFieldValue('gender', 'female'),
                  ]}
                />

                <GenderCard
                  selected={checkout.insured.gender === 'male'}
                  gender="male"
                  maleText={`${t('male')}`}
                  onClick={() => [
                    dispatch(
                      setInsuredInfo({
                        fieldName: 'gender',
                        fieldValue: 'male',
                      }),
                    ),
                    formik.setFieldValue('gender', 'male'),
                  ]}
                />
              </GenderBlock>
            </>
          </Inputs>
        </WhiteBox>

        <Buttons>
          <NavigationButton
            text={`${t('back')}`}
            buttonType="prev"
            onClick={() => {
              if (filter.chooseMethod === 'frani-choice') {
                return navigate('/tpl-insurance-for')
              }
              //
              if (filter.chooseMethod === 'user-choice') {
                return navigate('/tpl-insurance-for')
              }
              //
              return navigate('/tpl-insurance-for')
              //
            }}
          />
          <NavigationButton
            text={`${t('next')}`}
            buttonType="next"
            disabled={
              formik.isValid === true &&
              checkout.insured.cityzenship &&
              checkout.insured.dateOfbirth !== undefined &&
              (checkout.insured.cityzenship === 'GE'
                ? checkout.insured.idNumber && checkout.insured.idNumber.length === 11
                : true) &&
              (checkout.insured.cityzenship === 'GE'
                ? checkout.insured.translations?.ge?.firstName &&
                  checkout.insured.translations?.ge?.firstName.length >= 2
                : true) &&
              (checkout.insured.cityzenship === 'GE'
                ? checkout.insured.translations?.ge?.lastName && checkout.insured.translations?.ge?.lastName.length >= 2
                : true) &&
              checkout.insured.translations?.en?.firstName &&
              checkout.insured.translations?.en?.firstName.length >= 2 &&
              checkout.insured.translations?.en?.lastName &&
              checkout.insured.translations?.en?.lastName.length >= 2 &&
              checkout.insured.gender &&
              checkout.insured.gender?.length >= 2 &&
              diffage &&
              diffage >= 18
                ? false
                : true
            }
            onClick={() => {
              return navigate('/tpl-insurer')
            }}
          />
        </Buttons>
      </Content>

      <BackgroundIcon />
    </Wrapper>
  )
}
//
const GenderBlock = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 20px;
  grid-row-gap: 0px;
`
const ChooseGenderLabel = styled.label`
  font-size: 14px;
  color: ${Colors.primaryGrey};
`
const Inputs = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  grid-column-gap: 0px;
  grid-row-gap: 20px;
  margin-top: 20px;
`
const WhiteBox = styled.div`
  background-color: ${Colors.white};
  margin-block: 32px;
  box-shadow: 0 4px 50px 0 rgba(0, 0, 0, 0.04);
  max-width: 464px;
  margin-inline: auto;
  border-radius: 8px;
  padding: 48px;

  ${Responsive.mobile} {
    padding: 20px;
  }
`
const BoxTitle = styled.h6`
  font-size: 18px;
  color: ${Colors.primaryBlack};
`
const Buttons = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-inline: auto;
  width: 100%;
  margin-top: 48px;
  max-width: 368px;

  button {
    width: 100%;
    padding-inline: 0px;
    &:first-child {
      margin-right: 20px;
    }
  }

  ${Responsive.mobile} {
    max-width: 296px;
    margin-top: 40px;
    button {
      &:first-child {
        margin-right: 15px;
      }
    }
  }
`
const Content = styled.div`
  margin-top: 58px;
  z-index: 2;
  padding-inline: 20px;

  ${Responsive.mobile} {
    margin-top: 26px;
  }
`
const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: ${Colors.backgroundGrey};
  padding-bottom: 20px;
  min-height: 100vh;
  /*  */
`
//
export default TplForOther
